<template>
  <section class="anchor efficiency" :id="$t('header.nav[3].link')">
    <div class="container">
      <div class="row">
        <div class="col-x-lg-8 col-lg-7 col-md-7 col-sm-7 col-xs-12">
          <div class="efficiency__description">
            <h2
              class="efficiency__description-title"
              v-html="$t('home.efficiency.title')"
            ></h2>
            <div class="efficiency__description-list">
              <h5
                class="efficiency__description-list-title"
                v-html="$t('home.efficiency.list.title')"
              ></h5>
              <div
                class="efficiency__description-list-item"
                v-html="$t('home.efficiency.list.item_1')"
              ></div>
              <div
                class="efficiency__description-list-item"
                v-html="$t('home.efficiency.list.item_2')"
              ></div>
              <div
                class="efficiency__description-list-item"
                v-html="$t('home.efficiency.list.item_3')"
              ></div>
            </div>
            <div
              class="efficiency__description-info"
              v-html="$t('home.efficiency.info')"
            ></div>
            <router-link
              @click.native="mainMaEffectiveness()"
              :to="$t('home.efficiency.button.link')"
              class="efficiency__description-btn"
            >
              {{ $t("home.efficiency.button.title") }}
            </router-link>
          </div>
        </div>
        <div class="col-x-lg-4 col-lg-5 col-md-5 col-sm-5 col-xs-12">
          <div class="efficiency__image">
            <img src="~@/assets/img/home/efficiency/product.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Efficiency",
  methods: {
    mainMaEffectiveness() {
      // eslint-disable-next-line no-undef
      gtag("event", "click", {
        event_category: "main_ma_effectiveness"
      });
    }
  }
};
</script>
